app.factory('officeService', ['$q', 'baseService', 'objectHelper', 'config',

    function($q, baseService, objectHelper, config) {

        function OfficeService() {

            this.getDataPage = function (criteria) {
                return  baseService.post(config.API_URL + '/offices/dataPage', criteria).then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
                        dataPage.data = objectHelper.translateArray(dataPage.data, OfficeVO);
                        dataPage.data = objectHelper.convertTimesToDates(dataPage.data);

                        return dataPage;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getOfficesRelatedWithPatient = function (clinicId, patientId) {
                return  baseService.get(config.API_URL + '/offices/clinic/' + clinicId + '/patient/' + patientId + '/related').then(
                    function (successResponse) {
                        var dataPage = objectHelper.translateArray(successResponse, OfficeVO);


                        return dataPage;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }


        return new OfficeService();
    }
]);
